module.exports = __webpack_public_path__ + "static/media/icon-penalties.ddb64423.svg";